import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-construction-feed',
  templateUrl: './construction-feed.component.html',
  styleUrls: ['./construction-feed.component.css']
})
export class ConstructionFeedComponent implements OnInit {
  id
  type: 'news' | 'events' = 'news'
  faculty_image: any
  CONSTRUCTION_NAME: any
  CONSTRUCTIONObj: any
  subdetailslist: any[] = []
  galleryArry: any[] = []
  items: any[] = []
  loading = true

  // Pagination — mirrors the institute news/events pages.
  count = 12
  pageindex = 1
  hasMore = false

  constructor(private rest: RestService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    window.scrollTo(0, 0)
    // Prefer the construction subdomain (e.g. isc.aoa.edu.eg) over the route id.
    const hostId = this.rest.getConstructionIdByHost()
    this.id = hostId ? hostId : this.route.snapshot.paramMap.get('id')
    this.type = this.route.snapshot.data['type'] || 'news'
    this.getConstrction()
    this.getFeed()
  }

  // Loads the current page of news/events for this construction and appends it
  // when paginating. `hasMore` stays true while a full page comes back.
  getFeed() {
    this.loading = true
    const obs = this.type === 'events'
      ? this.rest.getConstructionEvents(this.count, this.pageindex, this.id)
      : this.rest.getConstructionNews(this.count, this.pageindex, this.id)
    obs.subscribe((res: any) => {
      const list = (this.type === 'events' ? res.LatestEvents : res.LatestNews) || []
      this.items = this.pageindex === 1 ? list : this.items.concat(list)
      this.hasMore = list.length >= this.count
      this.loading = false
    }, () => {
      this.loading = false
    })
  }

  moreItems() {
    this.pageindex = this.pageindex + 1
    this.getFeed()
  }

  // Opens the clicked item's detail page (news vs event have separate routes).
  openItem(item) {
    if (this.type === 'events') {
      this.router.navigate(['/event_Details', item.ID])
    } else {
      this.router.navigate(['/news_details', item.ID])
    }
  }

  // News use NEW_DATE; events use START_DATE.
  itemDate(item) {
    return item && (item.NEW_DATE || item.START_DATE)
  }

  get title(): string {
    return this.type === 'events' ? 'الفعاليات' : 'الأخبار'
  }

  // Indefinite form for sentences like "لا توجد أخبار".
  get titleBare(): string {
    return this.type === 'events' ? 'فعاليات' : 'أخبار'
  }

  getConstrction() {
    this.rest.getConstrction(this.id).subscribe((res: any) => {
      this.CONSTRUCTIONObj = res
      this.faculty_image = res.CONSTRUCTION_IMG_PATH
      this.CONSTRUCTION_NAME = res.CONSTRUCTION_NAME
      this.subdetailslist = res.subdetailslist
      this.galleryArry = res.gallery
    })
  }

  // Mirrors ConstructionComponent.has(): the API returns "" / null and a lone
  // "." placeholder for empty fields.
  has(value): boolean {
    if (!value) { return false }
    const v = String(value).trim()
    return v.length > 0 && v !== '.'
  }

  back() {
    this.router.navigate(['/constrction', this.id])
  }
}
